import { doordashInstacartExtensionId } from '@/constants/doordashInstacartExtension';

const authTokenMessageKind = 'authToken';
const syncIntervalMs = 10_000;
const excludedRoles = new Set(['customer', 'family', 'partner', 'affiliate']);

export const sendAuthTokenToExtension = () => {
  const token = localStorage.getItem('access_token');
  if (!token) {
    return;
  }

  try {
    const roles = JSON.parse(localStorage.getItem('roles') || 'null');
    if (!Array.isArray(roles) || roles.length === 0 || roles.some((role) => typeof role !== 'string' || excludedRoles.has(role))) {
      return;
    }
  } catch {
    return;
  }
  if (!globalThis.chrome?.runtime) {
    return;
  }

  chrome.runtime.sendMessage(doordashInstacartExtensionId, { kind: authTokenMessageKind, token }, () => {
    // reading lastError prevents Chrome from logging a warning when the extension is not installed.
    void chrome.runtime.lastError;
  });
};

export const startExtensionAuthSync = () => {
  sendAuthTokenToExtension();
  return setInterval(sendAuthTokenToExtension, syncIntervalMs);
};
